import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outing-header',
  templateUrl: './outing-header.component.html',
  styleUrls: ['./outing-header.component.scss']
})
export class OutingHeaderComponent implements OnInit{
  userId: string | null;
  userName: string | null;
  ngOnInit(): void {
    this.userId = localStorage.getItem("userId")
    this.userName = localStorage.getItem("userName")
  }

   isOpen = false; 

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }
}
